<template>
    <div class="user-center" data-automation="UserCenter">
        <div class="user-center-content">
            <my-header show-go-home show-user-name show-work-order></my-header>

            <!-- 内容 -->
            <div class="user-center-main">
                <my-side class="user-center-side"></my-side>
                <div class="user-center-view-box">
                    <ux-breadcrumb :data="breadData"></ux-breadcrumb>
                    <router-view
                        class="user-center-view"
                        data-automation="UserCenterMain"
                    ></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import upperUser from './template/upperUser';
import myHeader from '@c/myHeader/myHeader';
import mySide from '@c/mySide/mySide';

export default {
  name: 'UserCenter',
  components: {
    upperUser,
    myHeader,
    mySide
  },
  data() {
    return {
      props: {
        icon: 'icon',
        name: 'menu_name',
        children: 'child_menu'
      },
      isCollapse: false, // 迷你侧边栏是否显示
      userData: {} // 用户信息
    };
  },
  created() {
    this.userData = this.$store.state.login.userData;
    this.$getMenu();
  },

  methods: {
    /**
         * 退出登录
         */
    logout() {
      this.$api.login.logout();
      this.$store.commit('logout');
      this.$router.push('/login');
      this.$uxModal.hide();
    }
  },

  computed: {
    breadData() {
      return this.$route.meta.bread;
    }
  }
};
</script>

<style lang="scss" scoped>
.user-center {
    position: relative;
    width: 100%;
    overflow: auto;
    height: 100%;

    .my-header {
        position: relative;
        box-shadow: 0px 2px 6px 0px $color-box-shadow;
        background: #fff;
    }

    .user-center-content {
        position: relative;
        min-width: 1280px;
        min-height: 800px;
        height: 100%;
        z-index: 2;
    }

    .user-center-main {
        position: relative;
        display: flex;
        width: 100%;
        height: calc(100% - 60px);
        margin: 0 auto;
        background: $color-bg-disable;
        overflow: hidden;
    }

    .user-center-side {
        position: relative;
        flex: 0 0 auto;
        width: 240px;
        height: 100%;
        margin-top: 20px;
        box-sizing: border-box;
    }

    .user-center-view-box {
        padding-left: 20px;
        flex: 1;
        height: 100%;
        width: 100%;
        overflow: hidden;
        box-sizing: border-box;
    }

    .user-center-view {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
        z-index: 2;
        box-sizing: border-box;
        padding-right: 40px;
    }
}
</style>
